import { type ReactNode } from "react";

import { formatHHmmTime, TimeZoneEnum, type TTimeHHmm } from "@ryde/shared";

import { type IExpandedAvailability } from "./availability-cell.models";
import { TooltipContentStyled } from "./availability-cell.styled";
import { AvailabilityTooltipEntry } from "./availability-cell.tooltip-entry";

/** Availability times are wall-clock HH:mm, so they are formatted without a timezone shift. */
export const formatTimeRange = ({
  from,
  to,
  timeFormat,
}: {
  from?: TTimeHHmm;
  to?: TTimeHHmm;
  timeFormat: string;
}): string => {
  const fromLabel = from
    ? formatHHmmTime(from, timeFormat, TimeZoneEnum.UTC)
    : "";
  const toLabel = to ? formatHHmmTime(to, timeFormat, TimeZoneEnum.UTC) : "";

  if (fromLabel && toLabel) {
    return `${fromLabel} - ${toLabel}`;
  }

  return fromLabel || toLabel;
};

export const buildTooltipContent = (
  items: IExpandedAvailability[],
  dayGroupLabel: string,
  dayTypeLabel: string,
): ReactNode => {
  if (items.length === 0) {
    return null;
  }

  return (
    <TooltipContentStyled>
      {items.map((item, index) => (
        <AvailabilityTooltipEntry
          key={index}
          item={item}
          dayGroupLabel={dayGroupLabel}
          dayTypeLabel={dayTypeLabel}
        />
      ))}
    </TooltipContentStyled>
  );
};
